import React, {
  useState
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createFile,
  showFile,
} from '~/config/routes';
import Request from '~/providers/Request';
import FileRecord from '~/records/FileRecord';
import Form from './Form';
import isPresent from '~/utils/isPresent';
import { URL } from '~/config/uri';

function NewRecord({ history }){
  const [record, setRecord] = useState(new FileRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    setLoading(true);
    const { data } = record.toParams();
    const files = data.attributes.files;
    if(isPresent(files)) {
      const formData = new FormData();
      formData.append('file[]', files[0]);
      fetch(`${URL}/admin/files/upload`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${await Request.getAuth()}` },
      }).then((response) => {
        updateRecord({ data, response, saveAndContinue });
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
    } else {
      Request.post('/admin/files', { data }, {}, { controller: 'files' })
      .then((resp) => {
        setLoading(false);
        history.push(saveAndContinue ? createFile.spec : showFile.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
     }
  }

  const updateRecord = async ({ data, response = null, saveAndContinue = false }) => {
    if(response) {
      const fileSaved = await response.json();
      if(fileSaved.data && fileSaved.data.id){
        const id = fileSaved.data.id;
        Request.put(`/admin/files/${id}`, { data }, {}, { controller: 'files' })
        .then((resp) => {
          setLoading(false);
          history.push(saveAndContinue ? createFile.spec : showFile.reverse(resp.data));
        }).catch((e) => {
          console.error(e);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }
  };

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
